var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as s from './InvoiceViewV2.scss';
import { Layout, Text, Heading, Divider, Cell } from 'wix-style-react';
import LineItems from '../DocParts/LineItems';
import Totals from './Totals';
import { Customer } from './Customer/Customer';
import Comments from '../DocParts/Comments';
import { InvoicesBusinessInfo } from '../DocParts/InvoicesBusinessInfo/InvoicesBusinessInfo';
import InvoiceInfo from './InvoiceInfo';
import Status from './Status';
import { isStatusDisplayed } from './Status/status-utils';
import AscendLogo from '../AscendLogo';
import { translate, I18nextProvider } from 'react-i18next';
import RecurringInvoiceView from '../RecurringInvoicesView/RecurringInvoicesView';
import { InvoiceStatus, } from '@wix/ambassador-wix-quotes-web/types';
import * as _ from 'lodash';
import { WithTitleLoader } from '../loaders/loaders-builder';
import { isMobileView } from '../../core/isMobileView';
import { Logo } from '../DocParts/Logo/Logo';
import * as i18next from 'i18next';
import * as i18nextXHRBackend from 'i18next-xhr-backend';
var defaultNS = '';
var filePath = function (ns, lng) { return function (base) {
    return base + "assets/locale/" + ns + "/messages_" + lng + ".json";
}; };
function i18n(_a) {
    var locale = _a.locale, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b;
    return i18next.createInstance().use(i18nextXHRBackend).init({
        lng: locale,
        fallbackLng: 'en',
        keySeparator: '$',
        defaultNS: defaultNS,
        ns: ['invoice-view', defaultNS, 'locale-data'],
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: function (_a, _b) {
                var lng = _a[0];
                var ns = _b[0];
                return filePath(ns, lng)(baseUrl);
            },
            crossDomain: true
        }
    });
}
var Title = WithTitleLoader(function (_a) {
    var invoice = _a.invoice;
    return (React.createElement("div", { className: s.title, style: { marginBottom: '8px' } },
        React.createElement("div", { className: s.mobileHide },
            React.createElement(Heading, { className: s.title, appearance: 'H3', dataHook: "invoice-title" }, invoice.title)),
        React.createElement("div", { className: s.mobileShow },
            React.createElement(Text, { dataHook: "invoice-title", weight: "bold", size: "tiny" }, invoice.title))));
});
var InvoiceViewV2 = function (_a) {
    var invoice = _a.invoice, businessInfo = _a.businessInfo, _b = _a.status, status = _b === void 0 ? InvoiceStatus.Draft : _b, recurringInvoiceViewEnabled = _a.recurringInvoiceViewEnabled, recurringStandaloneViewEnabled = _a.recurringStandaloneViewEnabled, _c = _a.isUoU, isUoU = _c === void 0 ? false : _c, _d = _a.ascend, ascend = _d === void 0 ? false : _d, _e = _a.darkView, darkView = _e === void 0 ? false : _e, t = _a.t, onInvoiceReady = _a.onInvoiceReady, businessCustomFields = _a.businessCustomFields, documentCustomFields = _a.documentCustomFields, footer = _a.footer, customInvoiceNumberLabel = _a.customInvoiceNumberLabel, customFields = _a.customFields;
    var _f = React.useState(false), businessInfoReady = _f[0], setBusinessInfoReady = _f[1];
    var _g = React.useState(false), invoiceReady = _g[0], setInvoiceReady = _g[1];
    var lineItems = _.get(invoice, 'lineItems.lineItems', []);
    React.useEffect(function () {
        !!businessInfo && !_.isEmpty(businessInfo) && setBusinessInfoReady(true);
        !!invoice && !_.isEmpty(invoice) && setInvoiceReady(true);
    }, [businessInfo, invoice]);
    var lineItemList = lineItems.map(function (_a) {
        var name = _a.name, description = _a.description, price = _a.price, quantity = _a.quantity;
        var lineItemQuantity = quantity.serializedValue || 0;
        var lineItemPrice = price.serializedValue || 0;
        var lineItemTotal = lineItemQuantity * lineItemPrice;
        return {
            name: name,
            description: description,
            price: lineItemPrice,
            quantity: lineItemQuantity,
            total: lineItemTotal,
        };
    });
    var invoiceInfoStyle = "" + s.customInvoiceInfo;
    var footerLabels = {
        firstLabel: _.get(footer, 'notesLabel'),
        secondLabel: _.get(footer, 'legalTermsLabel'),
    };
    var InvoiceInfoView = function (props) {
        return isMobileView() ? (React.createElement("div", { className: s.detail + " " + invoiceInfoStyle }, props.children)) : (React.createElement(React.Fragment, null, props.children));
    };
    return (React.createElement("div", { className: s.invoiceContainer },
        React.createElement("div", { className: s.hideOnPrint }, recurringInvoiceViewEnabled && (React.createElement(RecurringInvoiceView, { recurringStandaloneViewEnabled: recurringStandaloneViewEnabled, invoice: invoice, darkView: darkView, isReady: invoiceReady }))),
        React.createElement("div", { className: s.hideOnPrint + " " + (isStatusDisplayed({ status: status, isUoU: isUoU }) && s.hangingStatus) },
            React.createElement(Status, { status: status, isUoU: isUoU })),
        React.createElement("div", { className: s.priceQuoteView },
            React.createElement("div", { className: "" + s.details, style: !isMobileView()
                    ? { padding: '48px', paddingBottom: '0px' }
                    : { padding: '20px' } },
                React.createElement(Layout, { gap: 18 },
                    React.createElement(Cell, { span: 4 },
                        React.createElement(Logo, { logo: businessInfo.logo, onImageReady: onInvoiceReady })),
                    React.createElement(Cell, { span: 8 },
                        React.createElement(InvoiceInfoView, null,
                            React.createElement(InvoiceInfo, { documentCustomFields: documentCustomFields, invoice: invoice, isRecurring: recurringInvoiceViewEnabled, status: status, isReady: invoiceReady, customInvoiceNumberLabel: customInvoiceNumberLabel, customFields: customFields }))),
                    React.createElement(Cell, { span: 12 },
                        React.createElement(InvoicesBusinessInfo, { businessInfo: businessInfo, isReady: businessInfoReady, businessCustomFields: businessCustomFields })),
                    React.createElement(Cell, { span: 12 },
                        React.createElement(Divider, null)),
                    React.createElement(Cell, { span: 12 },
                        React.createElement(Customer, { customer: invoice.customer, isReady: invoiceReady })),
                    React.createElement(Cell, { span: 12 },
                        React.createElement(Title, { invoice: invoice, isReady: invoiceReady })))),
            React.createElement(LineItems, { lineItems: lineItemList, currencyCode: invoice.currencyCode, locale: invoice.locale && invoice.locale.language }),
            React.createElement(Totals, { invoice: invoice }),
            React.createElement(Comments, { metaData: invoice.metaData, footer: footerLabels }),
            ascend && (React.createElement("div", { className: s.ascendFooter, "data-hook": "ascend-footer" },
                React.createElement(Text, { weight: "normal", size: "tiny", secondary: true, light: true }, t('invoice-view:price-quote.created-with')),
                React.createElement("div", { className: s.ascendLogo },
                    React.createElement(AscendLogo, null)))))));
};
var Comp = translate(['invoice-view', 'locale-data'], { wait: true })(InvoiceViewV2);
export default Comp;
export function InvoiceViewV2Full(props) {
    var i18nInstance = React.useMemo(function () { return i18n({ locale: props.locale, baseUrl: props.baseUrl }); }, [props.locale, props.baseUrl]);
    return React.createElement(I18nextProvider, { i18n: i18nInstance },
        React.createElement(Comp, __assign({}, props)));
}
//# sourceMappingURL=InvoiceViewV2.js.map